import React from 'react'
import styled from 'styled-components'
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { useHistory } from "react-router-dom";
import { IAppState } from '../../db/reducers';
import { device } from '../../theme';

const SButtonContainer = styled.div`
  min-width: 45px;
  @media ${device.tablet} {
    display: flex;
    flex-direction: row;
  }
`
interface IAdminButtonsProps {
  pollId: string;
  setShowDeleteWindow(st8: boolean): void;
  setCurrentPollId(pollId: string): void;
}


const AdminButtons: React.FunctionComponent<IAdminButtonsProps> = (props)  => {
  const history = useHistory();
  const { setCurrentPollId, setShowDeleteWindow, pollId } = props 

  const goToExistingPoll = (pollId: string) => {
    const encodedPollId = encodeURIComponent(pollId);
    history.push(`/admin/${encodedPollId}`);
  };

  const removePoll = (pollId: string) => {
    setCurrentPollId(pollId)
    setShowDeleteWindow(true)
  }

  return (
    <SButtonContainer>
      <button onClick={() => removePoll(pollId)} style={{ width: '5em', display: 'flex', justifyContent: 'center'}}>Delete!</button>
      <button onClick={() => goToExistingPoll(pollId)} style={{ width: '5em', display: 'flex', justifyContent: 'center'}}>View →</button>
    </SButtonContainer>
  )
}

const mapStateToProps = (state: IAppState) => ({});

const mapDispatchToProps = (dispatch: Dispatch) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(AdminButtons)